import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeneratedTimelineCardData, ScheduledEntry, EntriesThemeTypes, Sponsor } from 'src/app/_interfaces';
import { AdsService, RouteParserService, ScheduleEntriesService, AppStringsService } from 'src/app/_services';
import { SplideConfig } from 'src/app/_modules/carousel/splide-config';
import { NgClass } from '@angular/common';
import { CarouselComponent } from '../../carousel/carousel.component';
import { SlideComponent } from '../../carousel/slide/slide.component';
import { SponsorBannerComponent } from '../../sponsor-banner/sponsor-banner.component';
import { ScheduledEntryComponent } from '../../scheduled-entry/scheduled-entry.component';
import { SsrlocalstoreService } from 'src/app/_services/ssr-localstore.service';

type EntriesTypeTab = EntriesThemeTypes | `all`;

@Component({
    selector: 'app-live-entries',
    templateUrl: './live-entries.component.html',
    styleUrls: ['./live-entries.component.scss'],
    imports: [CarouselComponent, SlideComponent, NgClass, SponsorBannerComponent, ScheduledEntryComponent]
})
export class LiveEntriesComponent implements OnInit {
    @Input() timeline_id!: string;
    @Input() timeline_item!: GeneratedTimelineCardData;
    public aspect_ratio: string = '';
    public live_entries: ScheduledEntry[] = [];
    public all_live_entries: ScheduledEntry[] = [];
    public sorted_tabs: string[] = [];
    public selected_filter: EntriesTypeTab = `all`;
    public filter_tabs: Record<EntriesTypeTab | string, string> = { all: `golfscores.filter.all` };
    public header: string = `golfscores.section.header.live.title`;
    public entries_tabs: Record<EntriesThemeTypes, string> = {
        pga: `golfscores.filter.pga`,
        lpga: `golfscores.filter.lpga`,
        european_tour: `golfscores.filter.european_tour`,
        ladies_european: `golfscores.filter.ladies_european`,
        korn_ferry: `golfscores.filter.korn_ferry`,
        liv: `golfscores.filter.liv`,
        asian_tour: `golfscores.filter.asian_tour`,
        challenge_tour: `golfscores.filter.challenge_tour`,
        pga_tour_champions: `golfscores.filter.pga.champions`,
        sunshine_tour: `golfscores.filter.sunshine_tour`,
    };
    public header_banner: Sponsor | null = null;

    constructor(
        public appStringAPI: AppStringsService,
        private routeParser: RouteParserService,
        private router: Router,
        private adsService: AdsService,
        private entriesService: ScheduleEntriesService,
        private ssr: SsrlocalstoreService
    ) { }

    get liveEntries() {
        return this.live_entries && this.live_entries.length > 0;
    }

    get splideConfig() {
        return new SplideConfig().options({
            type: 'slide',
            perPage: 5,
            perMove: 1,
            gap: `15px`,
            autoWidth: true
        })
    }

    getAppString(key: string) {
        return this.appStringAPI.getAppString(key)
    }

    ngOnInit(): void {
        this.entriesService.entries.subscribe((entries) => {
            this.live_entries = entries.live;
            this.all_live_entries = entries.live;
        });
        this.header_banner = this.adsService.getSponsor('t1-tournaments-presenting');
        this.buildFilterTab();
    }

    buildFilterTab() {
        this.live_entries.forEach(entry => {
            const types = entry.theme.types;
            !!types?.length && types?.forEach(type => this.filter_tabs[type] = this.entries_tabs[type]);
        })
        this.sort_tabs();
    }

    sort_tabs() {
        const groups: Record<string, string[]> = {
            pga: [],
            lpga: [],
            european_tour: [],
            ladies_european: [],
            korn_ferry: [],
            liv: [],
            asian_tour: [],
            challenge_tour: [],
            pga_tour_champions: [],
            sunshine_tour: [],
            other: []
        };

        for (const tab of Object.keys(this.filter_tabs)) {
            if (tab === 'all') continue;

            const group = Object.keys(groups).find(key => {
                return tab.split('').every(char => key.includes(char))
            });
            if (group) {
                groups[group].push(tab);
            } else {
                groups.other.push(tab);
            }
        }

        this.sorted_tabs = ['all']

        for (const key of Object.keys(groups)) {
            if (groups[key]?.length) {
                this.sorted_tabs.push(key);
            }
        }
    }

    filter_entries(tab: EntriesTypeTab | string) {
        this.selected_filter = tab as EntriesThemeTypes;
        this.live_entries = ([`all`]).includes(tab) ? this.all_live_entries : this.all_live_entries.filter(entry => (entry.theme.types)?.includes(tab as EntriesThemeTypes));
    }

    routeLink(item: ScheduledEntry): void {
        // Save the teamId to use to end the tournament session in the next site launch/new total session 
        let sessions = JSON.parse(this.ssr.getItem('sessions') as string) || {};
        if (sessions?.tournament?.type) {
            sessions.tournament.team.id = item.team_id
            this.ssr.setItem('sessions', JSON.stringify(sessions))
        }
        const video_param = (
            item.theme?.play_video_ads ? `playad=true` :
                item.theme?.video_ad_id ? `playadwithid=${item.theme.video_ad_id}` : ``
        ).toLowerCase();
        const url = `bleachr://schedule/${item.team_id}/${item.id}?${video_param}`;

        if (item.theme?.play_video_ads || item.theme?.video_ad_id) {
            this.routeParser.parseBleachrRoutes(url);
        } else {
            this.router.navigate(['tournament', item.team_id, item.id]);
        }
    }
}
